import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme';

/**
 * Shared page chrome — title, subtitle, optional actions.
 * Keeps V0 screens visually consistent without card clutter.
 */
export default function PageHeader({ title, subtitle, actions = null, sticky = true }) {
  return (
    <Box
      className={sticky ? 'sticky-header page-header' : 'page-header'}
      sx={{
        px: { xs: 2, md: 3 },
        pt: { xs: 2, md: 2.5 },
        pb: 1.5,
        backgroundColor: tokens.surface,
        borderBottom: `1px solid ${tokens.border}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'flex-end' },
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="h1"
            sx={{
              fontFamily: "'Fraunces', 'Figtree', serif",
              fontWeight: 650,
              fontSize: { xs: 26, md: 30 },
              letterSpacing: '-0.025em',
              color: tokens.ink,
              lineHeight: 1.15,
              m: 0,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              sx={{ color: tokens.inkMuted, mt: 0.6, maxWidth: 520 }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
            {actions}
          </Box>
        )}
      </Box>
    </Box>
  );
}
